export default __webpack_public_path__ + "static/media/01Ujjain.3691c361.jpg";